module.exports = __webpack_public_path__ + "img/custom-solutions.7b6ff249.jpg";